import { GREEN_TEXT, RED_TEXT } from "../../constants/colors"

export const chooseColor = (expenseSum = 0, incomeSum = 0) =>
    (incomeSum > expenseSum ? GREEN_TEXT : RED_TEXT)

export const textColor = (color = "") => `text-${color}`